const equipType = [
    {value: 1, label: '挖掘机'},
    {value: 2, label: '推土机'},
    {value: 3, label: '装载机'},
    {value: 4, label: '叉车'},
    {value: 5, label: '压路机'},
    {value: 6, label: '摊铺机'},
    {value: 7, label: '平地机'},
    {value: 8, label: '港口场内车辆'},
    {value: 0, label: '其他'},
];

const goodsFlashSaleStatusList = [
    {value: 0, label: '已停止'},
    {value: 1, label: '已开始'}
];
const instrumentType = [
    {value: 1, label: '烟度计'},
    {value: 2, label: '计时器/秒表'},
    {value: 3, label: '转速仪'},
    {value: 6, label: '环境参数仪'},
    {value: 4, label: '30%滤光片'},
    {value: 8, label: '50%滤光片'},
    {value: 9, label: '70%滤光片'},
    {value: 10, label: '90%滤光片'}
];

export {
    equipType,instrumentType
}
